import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import { MotionConfigContext } from "../context/MotionConfigContext.js";
import { MotionContext } from "../context/MotionContext/index.js";
import { useVisualElement } from "./utils/use-visual-element.js";
import { useMotionRef } from "./utils/use-motion-ref.js";
import { useCreateMotionContext } from "../context/MotionContext/create.js";
import { loadFeatures } from "./features/load-features.js";
import { isBrowser } from "../utils/is-browser.js";
import { LayoutGroupContext } from "../context/LayoutGroupContext.js";
import { LazyContext } from "../context/LazyContext.js";
import { SwitchLayoutGroupContext } from "../context/SwitchLayoutGroupContext.js";
import { motionComponentSymbol } from "./utils/symbol.js";
function createMotionComponent({ preloadedFeatures, createVisualElement, useRender, useVisualState, Component }) {
  preloadedFeatures && loadFeatures(preloadedFeatures);
  function MotionComponent(props, externalRef) {
    let MeasureLayout;
    const configAndProps = {
      ...useContext(MotionConfigContext),
      ...props,
      layoutId: useLayoutId(props)
    };
    const { isStatic } = configAndProps;
    const context = useCreateMotionContext(props);
    const visualState = useVisualState(props, isStatic);
    if (!isStatic && isBrowser) {
      context.visualElement = useVisualElement(Component, visualState, configAndProps, createVisualElement);
      const initialLayoutGroupConfig = useContext(SwitchLayoutGroupContext);
      const isStrict = useContext(LazyContext).strict;
      if (context.visualElement) {
        MeasureLayout = context.visualElement.loadFeatures(
          // Note: Pass the full new combined props to correctly re-render dynamic feature components.
          configAndProps,
          isStrict,
          preloadedFeatures,
          initialLayoutGroupConfig
        );
      }
    }
    return jsxs(MotionContext.Provider, { value: context, children: [MeasureLayout && context.visualElement ? jsx(MeasureLayout, { visualElement: context.visualElement, ...configAndProps }) : null, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)] });
  }
  const ForwardRefComponent = forwardRef(MotionComponent);
  ForwardRefComponent[motionComponentSymbol] = Component;
  return ForwardRefComponent;
}
function useLayoutId({ layoutId }) {
  const layoutGroupId = useContext(LayoutGroupContext).id;
  return layoutGroupId && layoutId !== void 0 ? layoutGroupId + "-" + layoutId : layoutId;
}
export {
  createMotionComponent
};
//# sourceMappingURL=index.js.map
